// extracted by mini-css-extract-plugin
export var askAiIcon = "_m9-9";
export var container = "_m9-0";
export var groupSeparator = "_m9-a";
export var highlight = "_m9-4";
export var resultIcon = "_m9-5";
export var resultItem = "_m9-7";
export var resultSubtitle = "_m9-3";
export var resultTitle = "_m9-2";
export var resultsList = "_m9-1";
export var searchGroup = "_m9-6";
export var selected = "_m9-8";